<template>
  <div dir="rtl" class="behfam-logo-container">
    <div class="behfam-top-left-right-center-right-left behfam-bg"></div>
    <div class="behfam-top-left-right-center-right behfam-bg"></div>
    <div class="behfam-top-left-right-center-top behfam-bg"></div>
    <div class="behfam-top-left-right behfam-bg"></div>
    <div class="behfam-top-left-right-end behfam-bg"></div>
    <div class="behfam-top-left behfam-bg"></div>
    <div class="behfam-top behfam-bg"></div>
    <div class="behfam-right behfam-bg"></div>
    <div class="behfam-bottom behfam-bg"></div>
    <div class="behfam-bottom-left-one behfam-bg"></div>
    <div class="behfam-bottom-left-one-top behfam-bg"></div>
    <div class="behfam-bottom-left-one-top-right behfam-bg"></div>
    <div class="behfam-bottom-left-one-top-right-bottom behfam-bg"></div>
    <div class="behfam-bottom-left-one-top-right-bottom-left behfam-bg"></div>
    <div class="behfam-dot-first behfam-bg"></div>
    <div class="behfam-dot-second behfam-bg"></div>
    <p style="font-size: 1.4vw !important; font-weight: 900" class="behfam-loader-text">{{name}}</p>
  </div>
</template>
<script>
export default {
  data(){
    return{
      name: 'در حال بارگذاری...'
    }
  },
  mounted() {
    setTimeout(()=>{
      this.name = ''
    }, 3000)
  }
}
</script>
<style scoped>
.behfam-loader-text {
  position: absolute;
  width: 10vw;
  bottom: -16vw;
  right: -5vw;

}

.behfam-bg {
  background-color: rgb(35, 44, 106);
}

body {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  margin: 0;
  background-color: #ffffff;
  background-repeat: no-repeat;
  background-position: center;
}

.behfam-logo-container {
  position: relative;
  scale: 0.5;
  animation: behfam-fadeLogo 4s ease-in-out infinite alternate;
}

@keyframes behfam-fadeLogo {
  0% { opacity: 1; }
  50% { opacity: 0.6; }
  100% { opacity: 1; }
}

.behfam-top, .behfam-right, .behfam-bottom, .behfam-bottom-left-one, .behfam-bottom-left-one-top,
.behfam-bottom-left-one-top-right, .behfam-bottom-left-one-top-right-bottom-left,
.behfam-bottom-left-one-top-right-bottom, .behfam-top-left, .behfam-top-left-right,
.behfam-top-left-right-end, .behfam-top-left-right-center-right-left, .behfam-top-left-right-center-top,
.behfam-top-left-right-center-right {
  position: absolute;
  background-color: rgb(35, 44, 106);
  animation: behfam-stretchElement 2s ease-out;
}

@keyframes behfam-stretchElement {
  0% { transform: scale(0); }
  100% { transform: scale(1); }
}

.behfam-top { width: 19.0vw; height: 1.5vw; top: -12.3vw; right: -9.6vw; }
.behfam-right { width: 1.5vw; height: 23.5vw; top: -11.3vw; right: -9.6vw; }
.behfam-bottom { width: 19.5vw; height: 1.5vw; bottom: -12.3vw; right: -9.6vw; }
.behfam-bottom-left-one { width: 1.5vw; height: 9.3vw; bottom: -12.3vw; right: 8.4vw; }
.behfam-bottom-left-one-top { width: 9.5vw; height: 1.3vw; bottom: -4.3vw; right: -.4vw; }
.behfam-bottom-left-one-top-right { width: 1.8vw; height: 4.3vw; bottom: -8.3vw; right: -.4vw; }
.behfam-bottom-left-one-top-right-bottom-left { width: 1.8vw; height: 4.3vw; bottom: -8.3vw; right: 4vw; }
.behfam-bottom-left-one-top-right-bottom { width: 6.2vw; height: 2.3vw; bottom: -9.3vw; right: -.4vw; }
.behfam-top-left { width: 1.5vw; height: 13.3vw; top: -12.3vw; right: 7.8vw; }
.behfam-top-left-right { width: 13.8vw; height: 1.7vw; top: -0.7vw; left: -8vw; }
.behfam-top-left-right-end { width: 1.8vw; height: 3.2vw; top: -2.7vw; left: 4vw; }
.behfam-top-left-right-center-right-left { width: 1.8vw; height: 4.7vw; top: -4vw; left: -5.5vw; }
.behfam-top-left-right-center-top { width: 4.8vw; height: 1.7vw; top: -5vw; left: -5.5vw; }
.behfam-top-left-right-center-right { width: 1.8vw; height: 4.7vw; top: -5vw; left: -1.5vw; }

.behfam-dot-first, .behfam-dot-second {
  width: 2vw;
  height: 2vw;
  position: absolute;
  background-color: rgb(35, 44, 106);
  border-radius: 50%;
  animation: behfam-pulseDot 2s ease-in-out infinite alternate;
}

.behfam-dot-first { top: -8.5vw; right: 2vw; }
.behfam-dot-second { top: 2.9vw; right: -4vw; }

@keyframes behfam-pulseDot {
  0% { transform: scale(1); }
  100% { transform: scale(1.2); }
}
</style>
